export default __webpack_public_path__ + "static/media/dayImageActive.8c3ff334.svg";